import { Overlay, OverlayConfig, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge } from 'rxjs';
import { DateRangePickerAttributes } from '../components/date-range-picker/date-range-picker.component';

@UntilDestroy()
@Directive({
  selector: '[dateRangePicker]',
  standalone: true,
})
export class DateRangePickerDirective implements OnDestroy {
  @Input('dateRangePicker') dateRangePickerAttributes!: DateRangePickerAttributes;

  overlayRef?: OverlayRef;
  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
  ) {}

  @HostListener('click')
  openOverlay() {
    this.overlayRef = this.overlay.create(
      new OverlayConfig({
        positionStrategy: this.overlayPositionBuilder
          .flexibleConnectedTo(this.elementRef)
          .withPositions([{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }]),
        hasBackdrop: true,
        backdropClass: 'date-picker-transparent-backdrop',
      }),
    );

    const portal = new TemplatePortal(
      this.dateRangePickerAttributes.templateRef,
      this.viewContainerRef,
    );

    this.overlayRef.attach(portal);

    merge(
      this.dateRangePickerAttributes.cancelButtonClicked,
      this.dateRangePickerAttributes.applyButtonClicked,
    )
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.overlayRef?.detach();
      });

    this.overlayRef
      .backdropClick()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.overlayRef?.detach();
        this.dateRangePickerAttributes.resetPendingSelectionRange();
      });
  }

  ngOnDestroy(): void {
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }
}
